import { useEffect } from 'react';

interface RouteDepartureAdapter {
  ensureRouteAutoAuthorized?: () => Promise<unknown>;
}

/** Polls to persist scheduled route departure authorization when due. */
export function useRouteDepartureAutoAuth(
  adapter: RouteDepartureAdapter | null | undefined,
  enabled: boolean,
) {
  useEffect(() => {
    if (!enabled || !adapter?.ensureRouteAutoAuthorized) return undefined;

    const tick = () => {
      adapter.ensureRouteAutoAuthorized?.().catch(() => {});
    };

    tick();
    const id = window.setInterval(tick, 5_000);
    return () => window.clearInterval(id);
  }, [adapter, enabled]);
}
